import React, { ReactNode } from 'react';

interface IMainPageLayoutProps {
  presentationBlock: ReactNode | undefined;
  mainBlock: ReactNode | undefined;
}

export const MainPageLayout: React.FC<IMainPageLayoutProps> = ({ presentationBlock, mainBlock }) => {
  return (
    <>
      {presentationBlock}
      {mainBlock}
    </>
  );
};
